import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRODUCT_IMG } from './constants';
const includes = ['6 professional modules', '5 professional bonuses', 'Visual diagnostic workflows', 'Fault-finding tools', 'Diesel testing guides', 'Diagnostic decision trees', 'Professional workshop references'];
export function PricingCard() {
  return <section id="offer" className="bg-brand-carbon px-4 py-6 text-white" data-id="element-134" data-mp="1i4sm7qkb6at7">
      <div className="mx-auto max-w-2xl text-center" data-id="element-135" data-mp="2ernjy4shnfc5">
        <p className="mb-1 font-cond text-[12px] font-bold uppercase tracking-[0.2em] text-brand-yellow sm:text-sm" data-id="element-136" data-mp="29u5iezgsw2e6">
          Special Launch Offer
        </p>
        <h2 className="font-display text-[22px] leading-tight text-white sm:text-4xl" data-id="element-137" data-mp="251ceuex2j03o">
          🔧 DIESEL DIAGNOSTIC PRO™
        </h2>
        <p className="mb-2 font-cond text-[13px] font-semibold uppercase leading-snug text-brand-line sm:text-base" data-id="element-138" data-mp="2xj7xbzk1vh4z">
          The Complete Visual Fault-Finding System for Diesel Technicians
        </p>

        <a href={CHECKOUT_URL} className="block cursor-pointer" aria-label="Buy Diesel Diagnostic Pro" data-id="element-139" data-mp="32km2mtwnkxl9">
          <img src={PRODUCT_IMG} alt="Diesel Diagnostic Pro 6-in-1 system box set" className="mx-auto mb-2 w-full max-w-[220px] object-contain drop-shadow-2xl transition-transform duration-150 ease-out hover:scale-[1.02]" data-id="element-140" data-mp="37jymr6w53qk5" />
        </a>

        <div className="rounded-xl border-4 border-brand-yellow bg-white p-4 text-brand-carbon shadow-2xl" data-id="element-141" data-mp="2xsay1dqywnmd">
          <p className="mb-1.5 font-cond text-[13px] font-bold uppercase tracking-wide" data-id="element-142" data-mp="2js9rbho0ulyz">
            Complete 6-in-1 System
          </p>
          <ul className="mb-3 grid gap-x-4 gap-y-0.5 text-left text-[12px] font-semibold sm:grid-cols-2 sm:text-sm" data-id="element-143" data-mp="29vol4t09n4tk">
            {includes.map(item => <li key={item} data-id="element-144" data-mp="2evt36ngto7lw">✅ {item}</li>)}
          </ul>
          <p className="mb-2 font-display text-[19px] leading-tight sm:text-2xl" data-id="element-145" data-mp="84aawufmazdk">
            🔥 Get DIESEL DIAGNOSTIC PRO™ Today —{' '}
            <span className="bg-brand-yellow px-1" data-id="element-146" data-mp="d2bwpn4fhcsq">$26.90</span>
          </p>
          <CTAButton href={CHECKOUT_URL} data-id="element-147" data-mp="bmr0x1ljfcsm">🔧 GET INSTANT ACCESS</CTAButton>
          <p className="mt-2 text-[12px] font-semibold text-brand-muted" data-id="element-148" data-mp="bjv5bjx5x07c">
            Immediate Digital Access · 🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}